import React, { Component } from 'react';
import { Switch, Route, BrowserRouter as Router, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Test from './Test';
import Build from './Build';
import DistributionWidget from './DistributionWidget';
import $ from 'jquery';
import TestSetting from './TestSetting';
class deploySettings extends Component {
  componentDidMount() {
    (function () {

      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/test-and-deploy";
      var path1 = window.origin + "/platform/projectmgmt/test-and-deploy/";
      if (currentPath === path || currentPath === path1) {
        $("#build-tab").addClass('active');

      } else if (currentPath.includes('/test-and-deploy/Test')) {
        $("#test-tab").addClass('active');
      } else if (currentPath.includes('/test-and-deploy/DistributionWidget')) {
        $("#distributionWidget-tab").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-deploy-settings-tab")).addClass('active')
      }
      $("#build-tab,#test-tab,#distributionWidget-tab")
        .on("click", function () {
          $("#build-tab,#test-tab,#distributionWidget-tab")
            .removeClass('active');
          localStorage.setItem("last-deploy-settings-tab", $(this)[0].id);
          $(this).addClass('active')

        })

      $("#test-tab").on("click", function () {
        $("#test-agent-tab,#test-voice-tab")
          .removeClass('active');
        $("#test-agent-tab").addClass('active');
      })

      $("#distributionWidget-tab").on("click", function () {
        $("#widget-tab,#facebook-tab,#alexa-tab,#status-tab,#whatsapp-tab,#custom-app-tab,#signal-tab,#telegram-tab,#rcs-tab,#voice-tab,#telephony-tab,#store-tab")
          .removeClass('active');
        $("#status-tab").addClass('active');
      })

    })();
  }
  render() {
    return (
      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Test &amp; Deploy </h1>
                  <h6 className="taglineTxt">Build Interact &amp; Distribute</h6>

                </div>

              </div>
            </div>
          </div>
          <div className="container-fluid" style={{ marginLeft: '10px' }}>
            <div className="border-bottom"></div>
            {/* Nav tabs */}
            <div className="tab-class" >
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link to="/projectmgmt/test-and-deploy" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="build-tab">Build</li>
                </Link>
                <Link to="/projectmgmt/test-and-deploy/Test" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="test-tab">Test</li>
                </Link>
                <Link to="/projectmgmt/test-and-deploy/DistributionWidget" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="distributionWidget-tab">Deploy</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/projectmgmt/test-and-deploy/DistributionWidget" component={DistributionWidget}></Route>
          <Route path="/projectmgmt/test-and-deploy/Test" component={TestSetting}></Route>
          <Route path="/projectmgmt/test-and-deploy" component={Build}></Route>
        </Switch>
      </div>
    );
  }
}
export default deploySettings;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/deploySettings.js